"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInviteState = exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _GroupActionButtons = _interopRequireDefault(require("./GroupActionButtons"));

var _GroupMembersWidget = _interopRequireDefault(require("./GroupMembersWidget"));

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _GroupJoin = _interopRequireDefault(require("@insided/deprecated-preact-components/groups-destination/GroupJoin"));

var _service = require("./service");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

var _mixpanelEventsFromDestination = require("@insided/deprecated-preact-components/utils/mixpanelEventsFromDestination");

var _utils = require("./utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'group-statistics';
exports.cssAnchorName = cssAnchorName;

var pageReload = function pageReload() {
  window.location.reload();
};

var redirectToGroupsOverview = function redirectToGroupsOverview() {
  window.location.href = (0, _absoluteUrlRuntime.resolveUrl)('/groups');
};

var getInviteState = function getInviteState(inviteStatus) {
  switch (inviteStatus) {
    case 'ok':
      return {
        type: 'success',
        message: 'groups.invite.joined'
      };

    case 'fail:invalid-invite':
      return {
        type: 'error',
        message: 'groups.invite.invalid_link'
      };

    case 'fail:invalid-user-role':
      return {
        type: 'error',
        message: 'groups.invite.invalid_role'
      };

    default:
      return null;
  }
};

exports.getInviteState = getInviteState;

var GroupStatistics = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupStatistics, _Component);

  var _super = _createSuper(GroupStatistics);

  function GroupStatistics() {
    var _this;

    (0, _classCallCheck2.default)(this, GroupStatistics);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      userJoined: _this.props.isCurrentUserMember,
      isLoading: false,
      userSubscribed: true,
      invite: getInviteState(_this.props.inviteStatus),
      curatedContent: _this.props.group.category.curatedContent
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "joinGroup", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(onSuccess) {
        var _this$props$group;

        var userId, isPrivateGroup, event, _this$props$group2, _this$props$group3;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userId = (0, _insidedDataStorage.getInsidedData)('user').userid;
                isPrivateGroup = ((_this$props$group = _this.props.group) === null || _this$props$group === void 0 ? void 0 : _this$props$group.visibility) === _utils.GroupVisibility.Private;

                if (userId) {
                  _context.next = 6;
                  break;
                }

                event = new window.CustomEvent('GuestUserAction');
                window.dispatchEvent(event);
                return _context.abrupt("return");

              case 6:
                _this.setState({
                  isLoading: true
                });

                _context.prev = 7;
                _context.next = 10;
                return (0, _service.joinGroup)({
                  groupId: (_this$props$group2 = _this.props.group) === null || _this$props$group2 === void 0 ? void 0 : _this$props$group2.id,
                  csrfToken: _this.props.csrfToken
                });

              case 10:
                _this.setState({
                  userJoined: true,
                  isLoading: false,
                  userSubscribed: true
                });

                _publish.default.trackEvent('userevent', {
                  type: 'GroupMemberJoined',
                  payload: 'method1',
                  userId: userId,
                  addedBy: userId
                });

                if (onSuccess) {
                  onSuccess();
                }

                if (isPrivateGroup) {
                  (0, _mixpanelEventsFromDestination.trackRequestToJoinPrivateGroup)('RequestViaGroupDetailPage', (_this$props$group3 = _this.props.group) === null || _this$props$group3 === void 0 ? void 0 : _this$props$group3.id);
                }

                pageReload();
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](7);

                _this.setState({
                  isLoading: false
                });

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 17]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "leaveGroup", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _this$props$group4;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                isLoading: true
              });

              _context2.prev = 1;
              _context2.next = 4;
              return (0, _service.leaveGroup)({
                groupId: (_this$props$group4 = _this.props.group) === null || _this$props$group4 === void 0 ? void 0 : _this$props$group4.id,
                csrfToken: _this.props.csrfToken
              });

            case 4:
              _this.setState({
                userJoined: false,
                isLoading: false
              });

              _this.props.group.visibility === _utils.GroupVisibility.Hidden ? redirectToGroupsOverview() : pageReload();
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);

              _this.setState({
                isLoading: false
              });

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "subscribe", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var _this$props$group5;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this.setState({
                isLoading: true
              });

              _context3.prev = 1;
              _context3.next = 4;
              return (0, _service.subscribeUser)({
                groupId: (_this$props$group5 = _this.props.group) === null || _this$props$group5 === void 0 ? void 0 : _this$props$group5.id,
                csrfToken: _this.props.csrfToken
              });

            case 4:
              _this.setState({
                isLoading: false,
                userSubscribed: true
              });

              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](1);

              _this.setState({
                isLoading: false
              });

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 7]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "unsubscribe", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var _this$props$group6;

      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this.setState({
                isLoading: true
              });

              _context4.prev = 1;
              _context4.next = 4;
              return (0, _service.unsubscribeUser)({
                groupId: (_this$props$group6 = _this.props.group) === null || _this$props$group6 === void 0 ? void 0 : _this$props$group6.id,
                csrfToken: _this.props.csrfToken
              });

            case 4:
              _this.setState({
                isLoading: false,
                userSubscribed: false
              });

              _context4.next = 10;
              break;

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](1);

              _this.setState({
                isLoading: false
              });

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 7]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onManageGroupClick", function () {
      var _this$props$group7;

      window.location.href = (0, _absoluteUrlRuntime.resolveUrl)("/groups/".concat((_this$props$group7 = _this.props.group) === null || _this$props$group7 === void 0 ? void 0 : _this$props$group7.id, "/moderation?view=members"));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSaveTopics", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(topics, title) {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this.setState({
                  curatedContent: {
                    title: title,
                    curatedTopics: topics
                  }
                });

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x2, _x3) {
        return _ref5.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(GroupStatistics, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        var _this$props$group8;

        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.props.isCurrentUserMember) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return");

              case 2:
                _context6.prev = 2;
                _context6.next = 5;
                return (0, _service.checkUserSubscribed)((_this$props$group8 = this.props.group) === null || _this$props$group8 === void 0 ? void 0 : _this$props$group8.id);

              case 5:
                this.setState({
                  userSubscribed: true
                });
                _context6.next = 11;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](2);
                this.setState({
                  userSubscribed: false
                });

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[2, 8]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$props$group9;

      var _this$props = this.props,
          canSee = _this$props.canSee,
          group = _this$props.group,
          _this$props$featuredT = _this$props.featuredTopics,
          featuredTopics = _this$props$featuredT === void 0 ? [] : _this$props$featuredT,
          isCurrentUserModerator = _this$props.isCurrentUserModerator;
      var _this$state = this.state,
          userJoined = _this$state.userJoined,
          userSubscribed = _this$state.userSubscribed,
          isLoading = _this$state.isLoading,
          invite = _this$state.invite,
          curatedContent = _this$state.curatedContent;
      return (0, _preact.h)("div", null, invite !== null ? (0, _preact.h)(_message.default, {
        variant: invite.type,
        onDismiss: function onDismiss() {
          return _this2.setState({
            invite: null
          });
        },
        timer: invite.type !== 'error' ? 5000 : undefined
      }, (0, _preact.h)(_phrase.default, {
        p: invite.message,
        count: {
          g: (group === null || group === void 0 ? void 0 : group.name) || ''
        }
      })) : null, this.props.inviteStatus === 'fail:guest-user' ? (0, _preact.h)(_GroupJoin.default, {
        groupTitle: this.props.group.name,
        groupId: this.props.group.id,
        token: this.props.inviteToken
      }) : null, canSee && (0, _preact.h)("div", {
        className: "col"
      }, (0, _preact.h)("div", {
        className: "group-details-page_members-count"
      }, (0, _preact.h)(_GroupMembersWidget.default, {
        group: group
      })), (0, _preact.h)("div", {
        className: "group-details-page_action-buttons"
      }, (0, _preact.h)(_GroupActionButtons.default, {
        joinGroup: this.joinGroup,
        leaveGroup: this.leaveGroup,
        subscribe: this.subscribe,
        unsubscribe: this.unsubscribe,
        onManageGroupClick: this.onManageGroupClick,
        isLoading: isLoading,
        isUserMember: userJoined,
        isUserSubscribed: userSubscribed,
        isCurrentUserModerator: isCurrentUserModerator,
        groupId: group.id,
        groupTitle: group.name,
        curatedContentTitle: curatedContent.title,
        curatedContentTopics: featuredTopics,
        onSaveTopics: this.onSaveTopics,
        communityLocale: this.props.communityLocale,
        isPublicGroup: ((_this$props$group9 = this.props.group) === null || _this$props$group9 === void 0 ? void 0 : _this$props$group9.visibility) === _utils.GroupVisibility.Public
      }))));
    }
  }]);
  return GroupStatistics;
}(_preact.Component);

var _default = GroupStatistics;
exports.default = _default;